/**
 * Created by tdunham on 6/29/2017.
 */

import {Injectable}                         from '@angular/core';
import {HttpClient, HttpHeaders}            from "@angular/common/http";

import {AngularQuery}                       from "../query/angularquery";
import {Phrase}                             from "./phrase";
import {Tag}                                from './tag';

import {map}                                from "rxjs/operators";
import {Observable}                         from "rxjs";


/**
 * Extend the RestService to provide the list
 * of Tags.
 *
 */
@Injectable()
export class TagService {


	/**
	 * Initialize the object.
	 *
	 * @param {HttpClient} http  Access to HTTP.
	 */
	constructor(protected http: HttpClient) {}


	/**
	 * Delete the tag associated with the specified ID number.
	 *
	 * @param {number} id  The ID of the Tag to delete.
	 * @returns {Observable<Boolean>} Whether the delete was successful or not.
	 */
	deleteTag(id:number): Observable<Boolean> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_TAG, id.toString());
		query.useParams(false);
		query.useCacheBuster(false);
		let url:string = query.getUrl();

		return this.http
			.delete<Boolean>(url)
			.pipe(
				map(() => true)
			);

	}


	/**
	 * Get the list of Tag objects that are used as checkboxes for
	 * a given Sport entry.
	 *
	 * @param id       An Angular ReST API ID value from the "sport" table.
	 * @returns {any}  An Observable array of Tag or an error.
	 */
	getCheckboxes(id: number): Observable<Tag[]> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_SPORT_CHECKBOXES, id.toString());
		query.setPerPage(100);
		let url:string = query.getUrl();
		return this.http
			.get<Tag[]>(url);

	}


	/**
	 * Get the search phrases used when processing articles.
	 *
	 * @param {number} page   Which page of results is this?  Normally 0.
	 * @returns {Observable<Phrase[]>} The list of search phrases.
	 */
	getSearchPhrases(page:number = 0): Observable<Phrase[]> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_SEARCH_PHRASES);
		query.setPage(page);

		return this.http
			.get<Phrase[]>(query.getUrl());

	}


	/**
	 * Get the list of Tags as an Observable.
	 *
	 * @param query    An AngularQuery object that contains the information needed to get the tag list.
	 * @returns {any}  An Observable array of Tag or an error.
	 */
	getTags(query: AngularQuery): Observable<Tag[]> {

		let url:string = query.getUrl();
		return this.http
			.get<Tag[]>(url);

	}


	/**
	 * Post JSON data to the supplied URL.
	 *
	 * @param {string} url    The URL to post to.
	 * @param {string} json   The data as a JSON string.
	 * @return {Observable<Boolean>}  True or false depending on whether it worked or not.
	 */
	post(url: string, json: string): Observable<Boolean> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<Boolean>(url, json, { headers: headers })
			.pipe(
				map(() => true)
			);

	}


	/**
	 * Save the provided tag information.
	 *
	 * @param {string} url    The URL to post to.
	 * @param {string} json   The data as a JSON string.
	 * @return {Observable<Tag>}  The saved Tag data echoed back.
	 */
	save(url: string, json: string): Observable<Tag> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<Tag>(url, json, { headers: headers });

	}


	/**
	 * Search for matching tags and return an Observable.
	 *
	 * @param {string} tag       The tag being searched for.
	 * @returns {Observable<Tag[]>}  An Observable with Tags found.
	 */
	search(tag: string): Observable<Tag[]> {

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_TAG);           // Search the tag table.
		query.setPerPage(5);                                    // Limit results to 5 entries.
		query.addParameter('field', 'tag');                     // Do a search of the 'tag' field.
		query.addParameter('search', '%' + tag + '%');          // Do a 'LIKE' search for the tag.
		let url:string = query.getUrl();
		return this.http
			.get<Tag[]>(url);

	}

}



// WEBPACK FOOTER //
// ./src/app/services/tag/tag.service.ts